import { LinearProgress, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import Form from "../../../components/task-creator/Form";
import { useBreadcrumbs } from "../../../contexts/BreadcrumbContext";
import useTask from "../../../hooks/useTask";
import { Tag } from "../../../types/tag";

const initialFormData = {
  id: "",
  ecp_id: "",
  ecp_code: "",
  order_type: "stock",
  order_cycle: "",
  task_type: "new",
  tag_names: [],
  order_quantity: 1,
  tracking_numbers: "",
  to_user_id: "",
  urgent_note: "",
  content: "",
  content_images: [],
  more_images: [],
  ecp_id_ship_to: "",
  ecp_ship_to_code: "",
  is_reject_task: false,
  is_urgent_task: false,
  key_in_called_name: "",
  create_channel: "system",
};

export default function YourTaskEdit() {
  const params = useParams();
  const [queryParams] = useSearchParams();
  const { setBreadcrumbs } = useBreadcrumbs();

  const pageParam = queryParams.get("page");

  const parentBreadCrumbs = useMemo(() => {
    switch (pageParam) {
      case "task-creator":
        return {
          label: "Task Creator",
          to: "/user/task-creator",
        };
      case "key-in":
        return {
          label: "Key-In",
          to: "/user/keyin",
        };
    }
  }, [pageParam]);

  const page = useMemo(() => {
    switch (pageParam) {
      case "task-creator":
        return "task-creator";
      case "key-in":
        return "keyin";
      default:
        return null;
    }
  }, [pageParam]);

  useEffect(() => {
    setBreadcrumbs([
      {
        label: parentBreadCrumbs?.label || "",
        to: parentBreadCrumbs?.to || "",
      },
      { label: "Edit Your Task", to: "" },
    ]);
  }, [setBreadcrumbs, parentBreadCrumbs?.label, parentBreadCrumbs?.to]);

  const { data, dataLoading } = useTask(true, {
    fetchOne: true,
    id: params.id!,
  });

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (data) {
      setFormData({
        id: data?.id,
        ecp_id: data?.ecp?.id,
        ecp_code: data?.ecp?.code,
        order_type: data?.order_type,
        order_cycle: data?.order_cycle,
        task_type: data?.task_type,
        tag_names: data?.tags?.map((tag: Tag) => tag.name) || [],
        order_quantity: data?.order_quantity,
        tracking_numbers: data?.tracking_numbers?.join(", "),
        to_user_id: data?.to_user_id,
        urgent_note: data?.urgent_note,
        content: data?.content,
        content_images: data?.content_images || [],
        more_images: data?.more_images || [],
        ecp_id_ship_to: data?.ecp_id_ship_to,
        ecp_ship_to_code: data?.ecp_ship_to_code,
        is_reject_task: data?.is_reject_task,
        is_urgent_task: data?.is_urgent_task,
        key_in_called_name: data?.key_in_called_name,
        create_channel: data?.create_channel || "system",
      });
    }
  }, [data]);

  return (
    <>
      <Typography variant="subtitle1" className="font-bold mb-4">
        Edit Your Task
      </Typography>
      {dataLoading ? (
        <LinearProgress />
      ) : (
        <Form formData={formData} taskType="YOUR_TASK" page={page} />
      )}
    </>
  );
}
